export default __webpack_public_path__ + "static/media/social-media-3.02268a0f.png";